import { render } from "./PopUpAlert.vue?vue&type=template&id=032cbfae&scoped=true"
import script from "./PopUpAlert.vue?vue&type=script&lang=js"
export * from "./PopUpAlert.vue?vue&type=script&lang=js"

import "./PopUpAlert.vue?vue&type=style&index=0&id=032cbfae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032cbfae"]])

export default __exports__